import { styled } from '@mui/system';

export const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color          : ownerState.active ? '#784af4' : '#eaeaf0',
  display        : 'flex',
  justifyContent : 'center',
  alignItems     : 'center',
  width          : '28px',
  height         : '28px',
  border         : '2px solid',
  borderColor :
    ownerState.active || ownerState.completed ? '#A3CF5E' : '#F0F0F0',
  borderRadius    : '50%',
  backgroundColor : ownerState.active
    ? '#A3CF5E'
    : ownerState.completed
      ? '#ffffff'
      : '#F0F0F0',
  '& .StepIcon-completedIcon' : {
    color  : '#784af4',
    zIndex : 1,
    width  : '14px',
    height : '14px',
  },
  '& .StepIcon-stepNumber' : {
    fontSize   : '14px',
    fontWeight : '700',
    lineHeight : '24px',
    color      : ownerState.active ? '#ffffff' : '#BDBDBD',
  },
}));
